import theme from './theme/es_ES';
import profile from './profile/es_ES';
import member from './member/es_ES';
import organization from './organization/es_ES';
import console from './console/es_ES';
import aws from './aws/es_ES';
import activity from './activity/es_ES';

export default {
  ...theme,
  ...profile,
  ...organization,
  ...console,
  ...member,
  ...aws,
  ...activity,
};
